import DCTable from './table';

export default DCTable;
